import React, { useState, useEffect, useContext } from "react";
import QuestionLikeBox from "./../../components/QuestionLikeBlock";
import { ContainerQuestionLike } from "./QuestionLikeContainer.styled";
import { ALL_QUESTION_CATEGORIES } from "../../GraphQL/Queries";
import {
  CREATE_QUESTION_BANK,
  CREATE_QUESTION_SURVEY,
  UPDATE_QUESTION_BANK,
  UPDATE_QUESTION_SURVEY,
  CREATE_ANSWER_QUESTION_SURVEY,
} from "../../GraphQL/Mutations";
import { useMutation, useLazyQuery } from "@apollo/client";
import { getStateLogin } from "../LayoutHome/stateLogin";
import { NotificationManager } from "react-notifications";
import { ContextQuestions } from "../../Store/StoreQuestions";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import { messages } from "../../util/message";
import { theme as themeConfig } from "../../themes/themes";

const QuestionLikeContainer = (globalProps) => {
  const { identity, dataSurvey } = globalProps;
  const [stateQuestionsReducer, dispatch] = useContext(ContextQuestions);
  const [showLoader, setshowLoader] = useState(false);
  const [title, setTitle] = useState("");
  const [, setAnswerQuestionLike] = useState("");
  const [colorPicker] = useState(themeConfig.primary.purple);
  const [mandatory, setMandatory] = useState(false);
  const [elementKey, setelementKey] = useState(2);
  const [refTitle, setRefTitle] = useState("");
  const [refIsMandatory, setRefIsMandatory] = useState(false);
  const [refValidationText, setRefValidationText] = useState("");
  const [refColor, setRefColor] = useState("");
  const [refCategory, setRefCategory] = useState("0");
  const [refCantImage, setCantImage] = useState(0);
  const [categories, setcategories] = useState([]);
  const [createQuestionBank] = useMutation(CREATE_QUESTION_BANK);
  const [createQuestionSurvey] = useMutation(CREATE_QUESTION_SURVEY);
  const [createAnswerQuestionSurvey] = useMutation(
    CREATE_ANSWER_QUESTION_SURVEY
  );
  const [updateQuestionBank] = useMutation(UPDATE_QUESTION_BANK);
  const [updateQuestionSurvey] = useMutation(UPDATE_QUESTION_SURVEY);
  const [getQuestionCategories, { loading, error }] = useLazyQuery(
    ALL_QUESTION_CATEGORIES,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        if (!data.allCategoriesQuestion.withError) {
          const allCategories = data.allCategoriesQuestion.outputData.map(
            (c) => ({ ...c })
          );
          if (dataSurvey?.isGlobal) {
            setcategories(
              allCategories.filter((f) => f.description === "Global")
            );
          } else {
            setcategories(
              allCategories.filter((f) => f.description !== "Global")
            );
          }
        }
      },
    }
  );
  const [questionSettings, SetQuestionSettings] = useState([
    {
      id: 1,
      name: "radioButtonLike",
      value: "thumbUp",
      color: colorPicker,
      icon: "ThumbUpAltOutlinedIcon",
    },
    {
      id: 2,
      name: "radioButtonLike",
      value: "thumbDown",
      color: colorPicker,
      icon: "ThumbDownAltOutlinedIcon",
    },
  ]);
  const [showTooltipDescription, setShowTooltipDescription] = useState(false);
  const [tooltipInformationCheck, setTooltipInformationCheck] = useState(false);
  const [tooltipDescriptionText, setTooltipDescriptionText] = useState("");
  const [configQuestionStyle, setconfigQuestionStyle] = useState({
    question: {
      fontFamily: "",
      fontWeight: "",
      fontStyle: "",
      textDecoration: "",
      fontSize: "",
      color: "",
    },
    answer: {
      fontFamily: "",
      fontWeight: "",
      fontStyle: "",
      textDecoration: "",
      fontSize: "",
      color: "",
    },
    customStyle: false,
    background: "",
    alignment: "",
    typeQuestion: "QuestionLike",
    questionSettings: questionSettings,
    tooltip: {
      status: tooltipInformationCheck,
      descriptionText: tooltipDescriptionText,
    },
  });

  const changeTooltipInformationCheck = (status) => {
    configQuestionStyle.tooltip.status = status;
    let newConfigQuestionStyle = configQuestionStyle;
    setconfigQuestionStyle(newConfigQuestionStyle);
    setTooltipInformationCheck(status);
  };

  useEffect(() => {
    if (globalProps.GjsonConfiguration !== "") {
      const parsedJSON = JSON.parse(globalProps.GjsonConfiguration);
      if (parsedJSON.tooltip) {
        setTooltipInformationCheck(parsedJSON.tooltip.status);
        setTooltipDescriptionText(parsedJSON.tooltip.descriptionText);
      }
    }
  }, []);

  useEffect(() => {
    if (globalProps.GidQuestionSurvey) {
      let jsonConfSurveyQuestion = JSON.parse(globalProps.GjsonConfiguration);

      setTitle(globalProps.GnameQuestion);
      setRefTitle(globalProps.GnameQuestion);
      setRefCategory(globalProps.GidCategoryQuestion);
      setMandatory(
        globalProps.GisMandatory && globalProps.GisMandatory !== null
          ? globalProps.GisMandatory
          : false
      );
      setRefIsMandatory(globalProps.GisMandatory);
      setRefValidationText(globalProps.GvalidationText);
      SetQuestionSettings(jsonConfSurveyQuestion.questionSettings);
      setconfigQuestionStyle(jsonConfSurveyQuestion);
    }
    getQuestionCategories();
  }, []);

  let loadCategories = () => {
    if (loading) return <option key="0">Loading...</option>;
    if (error) return <option key="0">Error :(</option>;
    if (!loading && !error)
      return categories.map(
        ({ recordState, description, idCategoryQuestion }) => {
          if (recordState.toUpperCase() === "ACTIVE") {
            return (
              <option key={idCategoryQuestion} value={idCategoryQuestion}>
                {description}
              </option>
            );
          }
          return null;
        }
      );
  };

  let updateInQuestionSurvey = (idInBank, isMandatory, questionSettings) => {
    configQuestionStyle.questionSettings = questionSettings;

    updateQuestionSurvey({
      variables: {
        idQuestionSurvey: globalProps.GidQuestionSurvey,
        idQuestion: idInBank,
        idSurvey: globalProps.GidSurvey,
        jsonConfiguration: JSON.stringify(configQuestionStyle),
        isMandatory: isMandatory,
        order: globalProps.Gorder,
        active: true,
        lastUpdateUser: getStateLogin(),
      },
    }).then((response) => {
      dispatch({
        type: "UPDATE_QUESTIONS",
        payload: {
          GindexQuestion: globalProps.GindexQuestion,
          GisEdit: false,
          GnameQuestion: title,
          GidCategoryQuestion: refCategory,
          GisMandatory: mandatory,
          Gorder: globalProps.Gorder,
          GvalidationText: refValidationText,
          GjsonConfiguration: JSON.stringify(configQuestionStyle),
        },
      });
      setshowLoader(false);
    });
  };

  let saveQuestionSurvey = (
    idQuestion,
    isMandatory,
    questionSettings,
    copyText
  ) => {
    configQuestionStyle.questionSettings = questionSettings;
    createQuestionSurvey({
      variables: {
        idQuestion: idQuestion,
        idSurvey: globalProps.GidSurvey,
        jsonConfiguration: JSON.stringify(configQuestionStyle),
        isMandatory: isMandatory,
        order: globalProps.Gorder,
        active: true,
        createUser: getStateLogin(),
      },
    }).then((response) => {
      if (copyText != "") {
        dispatch({
          type: "CLONE_QUESTION",
          payload: {
            Gtype: "QuestionLike",
            GindexQuestion: globalProps.GindexQuestion + 1,
            Gactive: true,
            GidSurvey: globalProps.GidSurvey,
            GidQuestion: idQuestion,
            GidCategoryQuestion: refCategory,
            GnameQuestion: title + copyText,
            GvalidationText: refValidationText,
            GidQuestionSurvey: response.data.createQuestionSurvey,
            GisMandatory: mandatory,
            GjsonConfiguration: JSON.stringify(configQuestionStyle),
            Gorder: globalProps.Gorder + 1,
            GisEdit: false,
            GisDependent: false,
            GidParentQuestion: null,
            GdependentAnswer: null,
            clonePosition: globalProps.GindexQuestion + 1,
          },
        });
      } else {
        dispatch({
          type: "SAVE_QUESTIONS",
          payload: {
            GindexQuestion: globalProps.GindexQuestion,
            GisEdit: false,
            GnameQuestion: title,
            GidCategoryQuestion: refCategory,
            GisMandatory: mandatory,
            Gorder: globalProps.Gorder,
            GvalidationText: refValidationText,
            GidQuestion: idQuestion,
            GidQuestionSurvey: response.data.createQuestionSurvey,
            GjsonConfiguration: JSON.stringify(configQuestionStyle),
          },
        });
      }
      setshowLoader(false);
      createAnswerQuestionSurvey({
        variables: {
          idQuestionSurvey: response.data.createQuestionSurvey,
          idCategoryAnswer: 2,
          createUser: getStateLogin(),
        },
      })
        .then((data) => {
          if (data.createAnswerQuestionSurvey) {
            NotificationManager.success(
              "New questions were saved successfully",
              "",
              5000
            );
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    });
  };

  let saveQuestionBank = (clone) => {
    let title = refTitle;
    let category = refCategory;
    let isMandatory = refIsMandatory;
    let validationText = refValidationText;
    if (
      title.trim() !== "" &&
      parseInt(category) !== 0 &&
      ((isMandatory && validationText.trim() !== "") ||
        (tooltipInformationCheck && tooltipDescriptionText !== "") ||
        !isMandatory ||
        !tooltipInformationCheck)
    ) {
      if (
        !tooltipInformationCheck ||
        (tooltipInformationCheck && tooltipDescriptionText !== "")
      ) {
        setshowLoader(true);
        let copyText = clone ? " - Copy" : "";
        if (isMandatory && validationText !== "") {
          if (globalProps.GidQuestionSurvey && !clone) {
            updateQuestionBank({
              variables: {
                idQuestion: globalProps.GidQuestion,
                nameQuestion: title,
                validationText: validationText,
                idCategoryQuestion: parseInt(category),
                active: true,
                lastUpdateUser: getStateLogin(),
              },
            }).then(() => {
              updateInQuestionSurvey(
                globalProps.GidQuestion,
                isMandatory,
                questionSettings
              );
            });
          } else {
            createQuestionBank({
              variables: {
                nameQuestion: title + copyText,
                validationText: validationText,
                idCategoryQuestion: parseInt(category),
                active: true,
                createUser: getStateLogin(),
              },
            }).then((saveResponse) => {
              saveQuestionSurvey(
                saveResponse.data.createQuestionBank,
                isMandatory,
                questionSettings,
                copyText
              );
            });
          }
        } else {
          if (!isMandatory) {
            if (globalProps.GidQuestionSurvey && !clone) {
              updateQuestionBank({
                variables: {
                  idQuestion: globalProps.GidQuestion,
                  nameQuestion: title,
                  validationText: validationText,
                  idCategoryQuestion: parseInt(category),
                  active: true,
                  lastUpdateUser: getStateLogin(),
                },
              }).then(() => {
                updateInQuestionSurvey(
                  globalProps.GidQuestion,
                  isMandatory,
                  questionSettings
                );
              });
            } else {
              createQuestionBank({
                variables: {
                  nameQuestion: title + copyText,
                  validationText: validationText,
                  idCategoryQuestion: parseInt(category),
                  active: true,
                  createUser: getStateLogin(),
                },
              }).then((saveResponse) => {
                saveQuestionSurvey(
                  saveResponse.data.createQuestionBank,
                  isMandatory,
                  questionSettings,
                  copyText
                );
              });
            }
          } else if (mandatory && validationText === "") {
            if (globalProps.GidQuestionSurvey && !clone) {
              updateQuestionBank({
                variables: {
                  idQuestion: globalProps.GidQuestion,
                  nameQuestion: title,
                  validationText: validationText,
                  idCategoryQuestion: parseInt(category),
                  active: true,
                  lastUpdateUser: getStateLogin(),
                },
              }).then(() => {
                updateInQuestionSurvey(
                  globalProps.GidQuestion,
                  isMandatory,
                  questionSettings
                );
              });
            } else {
              createQuestionBank({
                variables: {
                  nameQuestion: title + copyText,
                  validationText: validationText,
                  idCategoryQuestion: parseInt(category),
                  active: true,
                  createUser: getStateLogin(),
                },
              }).then((saveResponse) => {
                saveQuestionSurvey(
                  saveResponse.data.createQuestionBank,
                  isMandatory,
                  questionSettings,
                  copyText
                );
              });
            }
          }
        }
      } else {
        handleNoTooltipDesMessage();
      }
    } else {
      handleNoQuestionTitle();
      handleNoCategory();
      handleNoMandatoryText();
      handleNoTooltipDesMessage();
    }
  };

  let handleNoQuestionTitle = () => {
    if (refTitle.trim() === "") {
      NotificationManager.warning(messages.QuestionTitle);
    }
  };

  let handleNoCategory = () => {
    if (parseInt(refCategory) === 0) {
      NotificationManager.warning(messages.QuestionCategory);
    }
  };

  let handleNoMandatoryText = () => {
    if (refIsMandatory && refValidationText === "") {
      NotificationManager.warning(messages.QuestionMandatory);
    }
  };

  let handleNoTooltipDesMessage = () => {
    if (tooltipInformationCheck && tooltipDescriptionText === "") {
      NotificationManager.warning(messages.QuestionTooltipDescription);
    }
  };

  let handleEdit = () => {
    if (
      stateQuestionsReducer.questions.filter((f) => f.GisEdit === true).length
    ) {
      NotificationManager.warning(
        "All questions must be saved before to edit another question",
        "",
        5000
      );
      return;
    }
    dispatch({
      type: "EDIT_QUESTIONS",
      payload: {
        GindexQuestion: globalProps.GindexQuestion,
        GisEdit: true,
      },
    });
  };

  let handleCancel = () => {
    let objG = stateQuestionsReducer.questions[globalProps.GindexQuestion];
    let jsonConfSurveyQuestion = JSON.parse(objG.GjsonConfiguration);

    setTitle(objG.GnameQuestion);
    setRefTitle(objG.GnameQuestion);
    setRefCategory(objG.GidCategoryQuestion);
    setMandatory(
      objG.GisMandatory && objG.GisMandatory !== null
        ? objG.GisMandatory
        : false
    );
    setRefIsMandatory(objG.GisMandatory);
    setRefValidationText(objG.GvalidationText);
    SetQuestionSettings(jsonConfSurveyQuestion.questionSettings);
    setconfigQuestionStyle(jsonConfSurveyQuestion);

    if (jsonConfSurveyQuestion.tooltip) {
      setTooltipInformationCheck(jsonConfSurveyQuestion.tooltip.status);
      setTooltipDescriptionText(jsonConfSurveyQuestion.tooltip.descriptionText);
    }

    dispatch({
      type: "CANCEL_QUESTIONS",
      payload: {
        GindexQuestion: globalProps.GindexQuestion,
        GisEdit: false,
      },
    });
  };

  let handleDelete = () => {
    setshowLoader(true);
    if (globalProps.GidQuestionSurvey !== 0) {
      updateQuestionBank({
        variables: {
          idQuestion: globalProps.GidQuestion,
          active: false,
          lastUpdateUser: getStateLogin(),
        },
      }).then((result) => {
        updateQuestionSurvey({
          variables: {
            idQuestionSurvey: globalProps.GidQuestionSurvey,
            idQuestion: globalProps.GidQuestion,
            idSurvey: globalProps.GidSurvey,
            jsonConfiguration: "",
            isMandatory: false,
            order: 0,
            active: false,
            lastUpdateUser: getStateLogin(),
          },
        }).then((resultUpdate) => {
          setshowLoader(false);
          let copy = JSON.parse(JSON.stringify(stateQuestionsReducer));
          copy.questions.splice(globalProps.GindexQuestion, 1);
          copy.questions.map((q, index) => {
            q.GindexQuestion = index;
            q.Gorder = index + 1;
          });
          dispatch({ type: "CLEAN_QUESTIONS" });
          dispatch({ type: "DELETE_QUESTIONS", payload: copy });
        });
      });
    } else {
      setshowLoader(false);
      let copy = JSON.parse(JSON.stringify(stateQuestionsReducer));
      copy.questions.splice(globalProps.GindexQuestion, 1);
      copy.questions.map((q, index) => {
        q.GindexQuestion = index;
        q.Gorder = index + 1;
      });
      dispatch({ type: "CLEAN_QUESTIONS" });
      dispatch({ type: "DELETE_QUESTIONS", payload: copy });
    }
  };

  let handleTextAreaText = (value) => {
    setTooltipDescriptionText(value);
    configQuestionStyle.tooltip.descriptionText = value;
    let newConfigQuestionStyle = configQuestionStyle;
    setconfigQuestionStyle(newConfigQuestionStyle);
  };

  return (
    <>
      <ContainerQuestionLike>
        <QuestionLikeBox
          title={title}
          setTitle={setTitle}
          setAnswerQuestionLike={setAnswerQuestionLike}
          questionSettings={questionSettings}
          SetQuestionSettings={SetQuestionSettings}
          colorPicker={colorPicker}
          mandatory={mandatory}
          setMandatory={setMandatory}
          editable={globalProps.GisEdit}
          elementKey={elementKey}
          setelementKey={setelementKey}
          loadCategories={loadCategories}
          refTitle={refTitle}
          setRefTitle={setRefTitle}
          refIsMandatory={refIsMandatory}
          setRefIsMandatory={setRefIsMandatory}
          refValidationText={refValidationText}
          setRefValidationText={setRefValidationText}
          refColor={refColor}
          setRefColor={setRefColor}
          refCategory={refCategory}
          setRefCategory={setRefCategory}
          saveQuestionBank={saveQuestionBank}
          handleEdit={handleEdit}
          handleCancel={handleCancel}
          refCantImage={refCantImage}
          setCantImage={setCantImage}
          error={error}
          loading={loading}
          configQuestionStyle={configQuestionStyle}
          setconfigQuestionStyle={setconfigQuestionStyle}
          handleDeleteQuestion={handleDelete}
          idQuestionSurvey={globalProps.GidQuestionSurvey}
          globalProps={globalProps}
          categories={categories}
          identity={identity}
          tooltipInformationCheck={tooltipInformationCheck}
          tooltipDescriptionText={tooltipDescriptionText}
          setShowTooltipDescription={setShowTooltipDescription}
          handleTextAreaText={handleTextAreaText}
          changeTooltipInformationCheck={changeTooltipInformationCheck}
          showTooltipDescription={showTooltipDescription}
        />
      </ContainerQuestionLike>
      {showLoader && <ModalLoader></ModalLoader>}
    </>
  );
};
export default QuestionLikeContainer;
